import { render, staticRenderFns } from "./PageStaff.vue?vue&type=template&id=e89f22c0&scoped=true&"
import script from "./PageStaff.vue?vue&type=script&lang=ts&"
export * from "./PageStaff.vue?vue&type=script&lang=ts&"
import style0 from "./PageStaff.vue?vue&type=style&index=0&id=e89f22c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e89f22c0",
  null
  
)

export default component.exports